'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.lumiance = lumiance;
exports.findColorInvert = findColorInvert;
exports.default = lumiance;
function lumiance(r, g, b) {
  if (typeof r === 'string') {
    ;

    var _convertHexToRGB = convertHexToRGB(r);

    var _convertHexToRGB2 = _slicedToArray(_convertHexToRGB, 3);

    r = _convertHexToRGB2[0];
    g = _convertHexToRGB2[1];
    b = _convertHexToRGB2[2];
  }if (Array.isArray(r)) {
    ;
    var _r = r;

    var _r2 = _slicedToArray(_r, 3);

    r = _r2[0];
    g = _r2[1];
    b = _r2[2];
  }return caculate(r, g, b);
}
function findColorInvert(r, g, b) {
  if (lumiance(r, g, b) > 0.55) return '#000000';
  return '#ffffff';
}

var coefficients = [0.2126, 0.7152, 0.0722];
var lowCoeffient = 1 / 12.92;

function gamma(x) {
  return Math.pow((x + 0.055) / 1.055, 2.4);
}

// http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
function caculate(r, g, b) {
  return [r, g, b].reduce(function (accumulator, x, i) {
    x = x / 255;
    var X = x <= 0.03928 ? x * lowCoeffient : gamma(x);
    return accumulator + X * coefficients[i];
  }, 0);
}
// https://bitsrc.io/materialui/colors/convert/hex-to-rgb/code
function convertHexToRGB(color) {
  if (color.length === 4) {
    var extendedColor = '#';
    for (var i = 1; i < color.length; i++) {
      extendedColor += color.charAt(i) + color.charAt(i);
    }
    color = extendedColor;
  }

  return [parseInt(color.substr(1, 2), 16), parseInt(color.substr(3, 2), 16), parseInt(color.substr(5, 2), 16)];
}